import React from 'react'


const ContentAction = ({ element, viewAction, removerContent }) => {
    return (
        <div>
            <div>
                <div>
                    <div className='w-40 bg-white border shadow rounded-xl '>
                        <ul className=''>

                            <li className='gap-1 p-2 border-b cursor-pointer hover:bg-blue-700 hover:text-white' onClick={viewAction}>

                                Preview Course
                            </li>
                            <li className='gap-1 p-2 cursor-pointer hover:bg-blue-700 hover:text-white' onClick={removerContent}>

                                {element?.isDisable ? "Active" : "Inactive"}

                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContentAction